import axiosInstance from "../../../utils/axiosInstance";
import { handleFrontendError } from "../../../utils/errorHandler";

export const AuthApis = {
  loginUser: async (formData) => {
    try {
      const response = await axiosInstance.post(`/auth/login`, { formData });
      return response.data;
    } catch (error) {
      return handleFrontendError(error, "Error logging in");
    }
  },

  fetchProfile: async () => {
    try {
      const response = await axiosInstance.get(`/profile`, {
        headers: {},
      });
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem fetching your profile",
      );
    }
  },

  fetchAccountStatus: async () => {
    try {
      const response = await axiosInstance.get(`/profile/account-status`, {
        headers: {},
      });
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem fetching your account status",
      );
    }
  },

  saveAddress: async (address) => {
    try {
      const response = await axiosInstance.post(`/profile/create-address`, {
        address,
      });
      return response.data;
    } catch (error) {
      return handleFrontendError(error, "Error creating user");
    }
  },

  createSecurePassword: async (p) => {
    try {
      const response = await axiosInstance.post(
        `/auth/create-secure-password`,
        { p },
      );
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem resetting your password",
      );
    }
  },

  createSubscription: async (tier) => {
    try {
      const response = await axiosInstance.post(`/stripe/create-subscription`, {
        tier,
      });
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem resetting your password",
      );
    }
  },

  passwordReset: async (formData) => {
    try {
      const response = await axiosInstance.post(
        `/auth/reset-password`,
        formData,
      );
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem resetting your password",
      );
    }
  },

  createAccount: async (formData) => {
    try {
      const response = await axiosInstance.post(
        `/auth/signup`,
        { formData },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem validating your emial",
      );
    }
  },

  verifyEmailToken: async (token, email, type) => {
    try {
      const response = await axiosInstance.get(`/auth/verify-token`, {
        params: { token, email, type },
      });
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem validating your email",
      );
    }
  },

  verifySubscriptionSession: async (sessionId) => {
    try {
      const response = await axiosInstance.post(
        `/stripe/verify-subscription-status`,
        {
          sessionId,
        },
      );
      // console.log(response)
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem validating your email",
      );
    }
  },

  passwordVerification: async (token) => {
    try {
      const response = await axiosInstance.get(
        `/auth/verify-reset-token/${token}`,
      );
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem validating your email",
      );
    }
  },

  updateStoreOperations: async (data) => {
    try {
      const response = await axiosInstance.post(
        `/profile/store-operations`,
        data,
      );
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem adding your store operations",
      );
    }
  },

  updatePassword: async (password, token) => {
    try {
      await axiosInstance.patch(`/auth/reset-password/${token}`, {
        password,
      });
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem adding your store operations",
      );
    }
  },

  updateApplicationNumber: async (applicationNumber) => {
    try {
      const response = await axiosInstance.post(
        `/profile/add/application-number`,
        { applicationNumber },
      );
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem adding your application number",
      );
    }
  },

  updateDeliveryInstructions: async (formData) => {
    try {
      const response = await axiosInstance.post(
        `/profile/update/delivery-instructions`,
        formData,
      );
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem creating your stripe account",
      );
    }
  },

  updateOnboardingStatus: async (data) => {
    try {
      const response = await axiosInstance.post(
        `/profile/update/account-status`,
        { data },
      );
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem creating your stripe account",
      );
    }
  },

  updateID: async (formData) => {
    try {
      const response = await axiosInstance.post(
        `/profile/update/idCard`,
        formData,
        {},
      );
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem uploading your ID card",
      );
    }
  },

  updateStripeAccount: async () => {
    try {
      const response = await axiosInstance.post(`/stripe/account`, {});
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem creating your stripe account",
      );
    }
  },

  updateAddress: async (formData) => {
    try {
      const response = await axiosInstance.post(
        `/profile/add/address`,
        formData,
      );
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem adding your address",
      );
    }
  },

  updateApprovalStatus: async (approval) => {
    try {
      const response = await axiosInstance.post(
        `/profile/update/approval-status`,
        { approval },
      );
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem adding your address",
      );
    }
  },

  emailSupport: async (emailSupportForm) => {
    try {
      const response = await axiosInstance.post(`/support`, {
        emailSupportForm,
      });
      return response.data;
    } catch (error) {
      return handleFrontendError(
        error,
        "There was a problem sending a message to support",
      );
    }
  },

  clearToken: async () => {
    try {
      const response = await axiosInstance.post(`/auth/logout`, {}, {});
      return response.data;
    } catch (error) {
      return handleFrontendError(error, "There was a problem logging you out");
    }
  },
};
